import React, { useContext, useEffect } from 'react'
import { Form, Field } from 'react-final-form'
import formStyles from 'styles/form.module.scss'
import modalStyles from 'styles/modal.module.scss'
import 'styles/beginForm.scss'
import { ModalContext } from 'providers/Modal'
import Close from './common/Close'
import { trackLoginFormOpen } from 'analytics/ga'
import { myDotUrl, baseUrl, baseDomain } from 'utils/parseDomain'
import FieldTracking from 'components/FieldTracking'
import {
  trackLinkClick,
  trackButtonClick,
  trackOnChangeCheckbox,
} from 'tracking/loginEvents'

const onSubmit = async values => {
  document.getElementById('frmLogin').submit()
}

const onLoginWithOTP = userName => {
  const otpUrl = `${myDotUrl}/otp-login/user`
  const goUrl = userName ? `${otpUrl}?username=${userName}` : otpUrl
  window.location.replace(goUrl)
}

const FormHeader = () => (
  <div data-testid="form_header" className={formStyles.header}>
    <img
      src="https://img2.shaadi.com/assests/2016/images/home-page-layer-logo.png"
      alt="Login to shaadi.com"
      style={{
        margin: '9px auto 15px',
        height: '40px',
        width: '40px',
      }}
    />
    <h2 className={`${formStyles.formTitle} ${formStyles.loginFormTitle}`}>
      Welcome back! Please Login
    </h2>
  </div>
)

const EmailOrMobile = () => {
  const { signupEmail } = useContext(ModalContext)
  return (
    <>
      <Field name="email" initialValue={signupEmail}>
        {({ input, meta }) => (
          <div className={`form-group col-md-12 ${formStyles.formEleWrap}`}>
            <label htmlFor="login_email" className={formStyles.layerLable}>
              Mobile No. / Email ID
            </label>
            <input
              data-testid="login_email"
              className={`form-control ${formStyles.formTextFreeField}`}
              type="text"
              placeholder="Enter Mobile no. / Email ID"
              {...input}
            />
            {meta.touched && meta.error && <span>{meta.error}</span>}
          </div>
        )}
      </Field>
      <FieldTracking name="email" modal="login" />
    </>
  )
}

const Password = () => (
  <>
    <Field name="password">
      {({ input, meta }) => (
        <div className={`form-group col-md-12 ${formStyles.formEleWrap}`}>
          <label htmlFor="login_password" className={formStyles.layerLable}>
            Password
          </label>
          <input
            data-testid="login_password"
            className={`form-control ${formStyles.formTextFreeField}`}
            type="password"
            placeholder="Enter password"
            {...input}
          />
          {meta.touched && meta.error && <span>{meta.error}</span>}
        </div>
      )}
    </Field>
    <FieldTracking name="password" modal="login" />
  </>
)

const LoginButton = () => (
  <button
    data-testid="sign_in"
    className={`btn btn-primary btn-md btn-block ${formStyles.signIn}`}
    type="submit"
    onClick={onClickLogin}
  >
    Login
  </button>
)

const onClickLogin = () => {
  trackButtonClick({
    fieldValue: 'Login',
  })
}

const LoginWithOtpButton = ({ values }) => (
  <button
    data-testid="login_with_otp"
    className={`btn btn-primary btn-md btn-block ${formStyles.loginWithOtp}`}
    type="button"
    onClick={() => onClickLoginWithOTP(values)}
  >
    Login with OTP
  </button>
)

const onClickLoginWithOTP = values => {
  onLoginWithOTP(values.email || '')
  trackButtonClick({
    fieldValue: 'Login with OTP',
  })
}

const AutoLogin = ({ values }) => (
  <Field name="autologin" type="checkbox">
    {({ input, meta }) => (
      <div
        data-testid="autologin"
        className={`form-group col-md-12 ${formStyles.formEleWrap}`}
      >
        <div className="form-check form-check-inline" style={{ width: '100%' }}>
          <input
            data-testid="stay_signed_in"
            className="form-check-input"
            type="checkbox"
            checked={values.autologin ? 'checked' : ''}
            style={{ marginRight: '5px' }}
            {...input}
            onClick={onChangeAutoLogin}
          />
          <label className={`form-check-label ${formStyles.staySignInLable}`}>
            Stay Logged in
          </label>
          <div
            data-testid="stay_signed_in_tooltip"
            className={`${formStyles.loginHelp} ${formStyles.tooltip}`}
          >
            <span className={formStyles.tooltiptext}>
              We recommend that you do not use this feature if you are signing
              in from a shared computer.
            </span>
          </div>
          <a
            data-testid="forgot_password"
            href={`${myDotUrl}/forgot-password/user`}
            className={formStyles.forgotPwdLink}
            style={{ marginLeft: 'auto' }}
            onClick={() => trackLinkClick({ fieldValue: 'forgot_password' })}
          >
            Forgot Password?
          </a>
        </div>
      </div>
    )}
  </Field>
)

const onChangeAutoLogin = event => {
  trackOnChangeCheckbox(event.target.checked)
}

const SignupLink = ({ switchForm }) => (
  <p className={modalStyles.switcher}>
    New to {baseDomain}?
    <a
      data-testid="sign_up_free"
      onClick={() => switchForm('register')}
      href="javascript:void(0)"
      className={formStyles.signUpFree}
    >
      Sign Up Free <span className={formStyles.signUpFreeArrow} />
    </a>
  </p>
)

const Login = () => {
  const { setActive } = useContext(ModalContext)
  const switchForm = formId => {
    setActive(formId)
  }

  useEffect(() => {
    trackLoginFormOpen()
  })
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ autologin: 'Y' }}
      render={({ handleSubmit, pristine, invalid, values }) => (
        <form
          className={formStyles.wrapper}
          onSubmit={handleSubmit}
          data-testid="login_form"
          id="frmLogin"
          name="frmLogin"
          action={`${baseUrl}/registration/user/login-submit`}
          method="POST"
        >
          <Close />
          <div className="form-row">
            <FormHeader />

            <EmailOrMobile />
            <Password />
            <AutoLogin values={values} />

            <LoginButton />
            <div className={formStyles.orSeparator}>
              <span className={formStyles.txtOrSeparator}>OR</span>
            </div>
            <LoginWithOtpButton values={values} />

            <SignupLink switchForm={switchForm} />
          </div>
        </form>
      )}
    />
  )
}

export default Login
